import { FC } from 'react'
import { CardStatus } from 'components/features/creditCard/creditCardPage/CardStatus/CardStatus'
import Flex from 'components/atoms/Flex/Flex'
import { CC_SUPPORT_PHONE_NUMBER } from 'components/features/creditCard/creditCardStore/constants'

export const PayCardSuccessContent: FC<{}> = () => (
  <Flex>
    <figure>
      <CardStatus iconSlug='checkmark' />
    </figure>
    <h1>You are all set!</h1>
    <p>
      If you think someone used your card without your permission, please call
      customer support right away at{ ' ' }
      <a href={ 'tel:' + CC_SUPPORT_PHONE_NUMBER }>{ CC_SUPPORT_PHONE_NUMBER }</a> for help.
    </p>
    <p>
      To learn more, please see the Consumer Credit Card Agreement “Disputed
      Transactions” and “Security and Lost or Stolen Card”
    </p>
  </Flex>
)
